export default {
  build: 'Build',
  better_games: 'Better games, faster',
  download_view_more: 'View More',
  client_side_sdk: 'CLIENT-SIDE SDK',
  server_side_sdk: 'SERVER-SIDE SDK',
  download_tools: 'TOOLS',
  sample_demo: 'SAMPLE DEMO',
  download_engine: 'Engine',
  supporting_system: 'Supporting System',
  download_format: 'Format',
  download_microservice_format: 'Supporting Environment',
  download_latest: 'Latest',
  download_whitelist: 'Whitelist',
  download_list_number: 'Download List · {{listNumber}}',
  download_list_empty: 'Haven\'t selected anything to download yet',
  download_list_btn: 'Download',
  download_modal_title: 'Preparing Download',
  dowload_step_one: 'Step1',
  dowload_step_two: 'Step2',
  link_to_the_title: 'Link to the Title',
  packaging_integration: 'Packaging & Integration',
  download_list_tips:
    'When you select the game, we will automatically inject some parameters into the package body, these parameters can also be replaced manually according to the documentation after the download is complete.',
  download_studio: 'Studio',
  download_tips_fetching: 'Fetching package from remote server...',
  download_tips_unzipping: 'Unzipping package and inserting parameters...',
  download_tips_generated: 'Package is being generated...',
  download_tips_uploading: 'Re-uploading the package...',
  download_tips_cdn: 'CDN pre-warming, task in progress...',
  download_tips_success:
    'Task completed successfully, initiating browser download...',
  cancel_download: 'Cancel Download',
  cancel_download_time_remaining_tips:
    'About {{timeRemaining}} minutes to finish packing. Are you sure you want to cancel the download?',
  cancel_download_btn_continue: 'Continue',
  cpp: 'C++ Game Engine',
  ue_plugin: 'UE Plugin',
  unity_plugin: 'Unity Plugin',
  ps_sdk: 'PS SDK',
  gdk: 'GDK',
  please_select_studio: 'Please select studio',
  please_select_game: 'Please select game',
  please_select_env: 'Please select env',
  cancel_download_success: 'Cancel download success!',
  cancel_download_failed: 'Cancel download failed!',
  host_platform: 'Console',
  computer_platform: 'Desktop',
  mobile_platform: 'Mobile',
  show_update_time: 'Update Time:',
  ps_sdk_version_and_gdk_version_required:
    'PS SDK Version and GDK Version of this engine are required.',
  ps_sdk_version_required: 'PS SDK Version of this engine are required.',
  gdk_version_required: 'GDK Version of this engine are required.',
  download_failed:
    'Download failure or more than five downloads in ten minutes.',
  client_platform_unselected: 'Please select the distribution platform first.',
  client_platform_nonsupport: 'No SDK matching the conditions was found.',
  comingSoon: 'Coming Soon',
  service_download_options: 'Service Download Options',
  downloaded_sdk_selected_tips:
    'The downloaded SDK will contain only the resource for the selected services.',
  does_not_support: '{{name}} does not support {{config}} yet.',
  include_second: '(Include {{name}})',
};
